import React from 'react'
import TableCatégorie from '../../Components/table/TableCatégorie'

const Catégorie = () => {
  return <TableCatégorie />
}

export default Catégorie
